import { render, staticRenderFns } from "./Notifiche.vue?vue&type=template&id=1897f67a&"
import script from "./Notifiche.vue?vue&type=script&lang=js&"
export * from "./Notifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports